"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fix_parent_1 = require("./fix$parent");
var funcParams_1 = require("./funcParams");
function validPropFunction(rule, cache) {
    if (cache === void 0) { cache = true; }
    var s = '';
    if (typeof rule === 'string') {
        rule = (0, fix_parent_1.default)(rule);
        s = "return (" + rule + ")";
    }
    else if (Array.isArray(rule)) {
        for (var _i = 0, rule_1 = rule; _i < rule_1.length; _i++) {
            var item = rule_1[_i];
            if (typeof item === 'string') {
                s += (0, fix_parent_1.default)(item) + '\r\n';
            }
            else {
                var ss = item.when || item.if || 'true';
                ss = (0, fix_parent_1.default)(ss);
                var ss2 = item.value;
                if (ss2 === undefined) {
                    ss2 = ss;
                }
                else {
                    if (typeof ss2 === 'string') {
                        ss2 = (0, fix_parent_1.default)(ss2);
                    }
                }
                s += "if (" + ss + ") return (" + ss2 + ");\r\n";
            }
        }
        s = 'var $result=null;\r\n' + s + 'return $result;';
    }
    // console.log('create valid function', rule, s);
    return new Function(funcParams_1.default, s);
}
exports.default = validPropFunction;
//# sourceMappingURL=validPropFunction.js.map